<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :openDialog="isOpen"
      :widthDialog="'450px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('closed')"
    >
      <template #body>
        <div>
          <h3 class="dialogTitle">Mẫu giấy giới thiệu</h3>
          <el-form :model="form" ref="form" label-position="left">
            <el-form-item label="Ông/Bà:" prop="name">
              <el-input
                type="textarea"
                :rows="1"
                resize="none"
                v-model="form.name"
                maxlength="2000"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="Chức vụ:" prop="name">
              <el-input
                type="textarea"
                :rows="1"
                resize="none"
                v-model="form.position"
                maxlength="2000"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="Địa chỉ:" prop="name">
              <el-input
                type="textarea"
                :rows="1"
                resize="none"
                v-model="form.address"
                maxlength="2000"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="Nội dung làm việc:" prop="name">
              <el-input
                type="textarea"
                :rows="2"
                resize="none"
                v-model="form.content"
                maxlength="2000"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template #footer>
        <div class="flex-row flex__right form-button__action">
          <el-button :disabled="isLoading" class="dialogBtnPrimary" @click="submit">
            <span class="flex-row flex__center">
              <i
                :class="[
                  !isLoading
                    ? 'fas fa-arrow-alt-circle-right'
                    : 'el-icon-loading'
                ]"
              ></i>
              &nbsp;Xác nhận
            </span>
          </el-button>
          <el-button
            type="info"
            size="mini"
            class="btn__cancel btn-none__border"
            :disabled="isLoading"
            @click="$emit('closeDialog')"
          >
            <i
              :class="[
                  !isLoading
                    ? 'fas fa-arrow-alt-circle-right'
                    : 'el-icon-loading'
                ]"
            ></i>
            &nbsp;Hủy
          </el-button>
        </div>
      </template>
    </dialogTemplate>
  </div>
</template>

<script>

export default {
  name: "DynamicFieldFormDialog",
  props: ["isOpen", "isLoading"],
  filters: {},
  components: {
    dialogTemplate: () => import('../../common/custom-dialog.vue'),
  },
  mounted() {
  },
  mixins: [],
  data() {
    return {
      form:{
        name:null,
        position: null,
        address: null,
        content: null,
        date_valid: ''
      }
    }
  },
  computed: {},
  created() {
  },

  methods: {
    submit() {
      this.$emit("submit", this.form);
    },
    resetForm() {
      this.form.name = null
      this.form.position = null
      this.form.address = null
      this.form.content = null
    },
    cancel() {
      this.resetForm()
      this.$emit('closeDialog')
    }
  }
}


</script>

<style scoped>
.content {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/DynamicFieldFormDialog.vue